import { Typography, Grid2, Box } from "@mui/material";
import Styles from "./Mob.module.css"
import pic from "../../../../ui-utils/latestPics/EquityAcc.svg"
import { useLanguage } from "../../../../Context/LangContext";
import en from "../../../../i18n/English/Trade Invest/account.json";
import hi from "../../../../i18n/Hindi/Trade Invest/account.json";
import kn from "../../../../i18n/Kannada/Trade Invest/account.json";
import ma from "../../../../i18n/Marathi/Trade Invest/account.json";
import gu from "../../../../i18n/Gujarati/Trade Invest/account.json";
export default function AccountMob() {
    const { language } = useLanguage();
    const translations = { en, hi, kn, ma, gu };
    const t = translations[language];
    return (
        <>
            <Box className={Styles.outerBox}>
                <div className={Styles.headingContainer}>
                    <div className={Styles.gradientBackground}></div>
                    <Typography className={Styles.heading}>
                        {t.heading}
                    </Typography>
                </div>
                <Typography className={Styles.subtxt}>
                    {t.subtxt}
                </Typography>
                <Grid2 className={Styles.picCard}>
                    <img src={pic} alt="equity" className={Styles.pic} />
                </Grid2>

                <Grid2 className={Styles.txtCard}>
                        <Typography className={Styles.innertxt1}>
                        {t.innerText1}
                        </Typography>

                        <Typography className={Styles.innertxt1} sx={{ paddingTop: "20px" }}>
                        {t.innerText2}
                        </Typography>

                    </Grid2>



            </Box>
        </>
    )
}